// store
import {
    NEW_REQUESTS_COUNT,
  } from "../../store/actions/manager";
import { getRequestToCreateListApi } from "../../api/manager";

  const state = {
    newRequests: [],
    newRequestsCount: localStorage.getItem("newRequests"),
  };
  
  const getters = {
    newRequests: state => state.newRequests,
    newRequestsCount: state => state.newRequestsCount,
  };
  
  const actions = {
    [NEW_REQUESTS_COUNT]: ({commit}) => {
      getRequestToCreateListApi({"start": 0,
      "limit": 20}).then(resp => {
        localStorage.setItem("newRequests", resp.data.items.filter(it => it.status == 0).length);
        state.newRequests = resp.data.items.filter(it => it.status == 0)
        state.newRequestsCount = resp.data.items.filter(it => it.status == 0).length
        commit(NEW_REQUESTS_COUNT, resp.data.items.filter(it => it.status == 0));
      });
    },
  };

  const mutations = {
    [NEW_REQUESTS_COUNT]: (state, payload) => {
      localStorage.setItem("newRequests", payload.length);
      console.log('newRequests', payload.length);
      state.newRequests = payload
    },
  };
  
  export default {
    state,
    getters,
    actions,
    mutations
  };
  